import { Flex } from '@chakra-ui/react';
import { SimpleDashboard } from 'layouts/dash/types';

export default function SegurancaPsicologica(props: SimpleDashboard) {
  return <Flex w="100%" h="100%" justifyContent="center" alignItems="center"></Flex>;
}
